// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2STFa","type":"styles_type__3zlDg","choices":"styles_choices__2dbxp"};